import { render } from "./instructor-quiz-question-modal.vue?vue&type=template&id=2894be1a"
import script from "./instructor-quiz-question-modal.vue?vue&type=script&lang=js"
export * from "./instructor-quiz-question-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__